import React from "react";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
import usePermissions from "hooks/usePermissions";
import DocsHelper from "util/DocsHelper";
import DocumentationLink from "components/support/DocumentationLink";
import { Icon, TextOverflowEllipsis } from "components/common";
import getInaccessibleFiltersFromView from "search-filter/logic/getInaccessableFiltersFromView";
import useView from "views/hooks/useView";
const StyledAlert = styled(Alert)`
  margin-bottom: 10px;
  ${(props) => props.$isCompact && css`
      padding: 7px 10px;
    `}
`;
const FilterList = styled.ul`
  padding-left: 20px;
  overflow: auto;
  ${(props) => css`
    max-height: ${props.$isCompact ? "52px" : "100px"};
  `}

  li {
    list-style: initial;
  }
`;
const SearchFilterTransformationWarning = ({ disabledViewCreation = false, isCompact = false }) => {
  const { isPermitted } = usePermissions();
  const view = useView();
  const { t } = useTranslation("enterprise_search");
  if (disabledViewCreation) {
    return null;
  }
  const inaccessibleSearchFilters = getInaccessibleFiltersFromView(view, isPermitted);
  if (!(inaccessibleSearchFilters == null ? void 0 : inaccessibleSearchFilters.size)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "warning", $isCompact: isCompact }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "search_filter_transformation_warning.copy_warning",
      count: inaccessibleSearchFilters.size,
      values: { count: inaccessibleSearchFilters.size },
      components: {
        docsLink: /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.WELCOME, text: /* @__PURE__ */ React.createElement(Icon, { name: "lightbulb_circle" }) })
      }
    }
  ), /* @__PURE__ */ React.createElement(FilterList, null, inaccessibleSearchFilters.toArray().map((filter) => /* @__PURE__ */ React.createElement("li", { key: filter.id }, /* @__PURE__ */ React.createElement(TextOverflowEllipsis, null, filter.title || filter.queryString)))));
};
export default SearchFilterTransformationWarning;
